module.exports = __webpack_public_path__ + "static/media/sling_heart.6a8dc72d.png";